export default class AppCustomerFilter {
    constructor () {
        this.initAll();
    }

    initAll () {
        let self = this;

        let $containers = $('[data-toggle=customerfilter]');
        $containers.each(function () {
            self.init($(this));
        });
    }

    init ($container) {
        let self = this;

        let $filters = $container.find('[data-filter]');
        $filters.on('click', function (e) {
            e.preventDefault();
            let $newFilter = $(this);
            let $activeFilters = $filters.filter('.btn-warning');
            $activeFilters.each(function () {
                let $activeFilter = $(this);
                if ($activeFilter.attr('data-filter-group') === undefined || $activeFilter.attr('data-filter-group') !== $newFilter.attr('data-filter-group')) {
                    $activeFilter.removeClass('btn-warning');
                }
            });
            $newFilter.toggleClass('btn-warning');

            if ($filters.filter('.btn-warning').length === 0) {
                $filters.filter('.reset-filter').addClass('btn-warning');
            }

            $container.trigger('render.filter');
        });

        $container.on('render.filter', function () {
            self.filterList($container);
            window.app.mediaModal.load();
        });
    }

    filterList ($container) {
        let $filters = $container.find('[data-filter]');
        let $activeFilters = $filters.filter('.btn-warning');
        let $items = $container.find('.list').children();
        $items.removeClass('d-none');

        $items.each(function () {
            let $item = $(this);
            let filtersMatched = 0;

            $activeFilters.each(function () {
                let $activeFilter = $(this);
                let column = $activeFilter.data('column');
                let value = $activeFilter.data('filter');

                if (value && column) {
                    switch (column) {
                    case 'flag':
                        if ($item.find('[data-flag=' + value + ']').first().data('flag-state')) {
                            filtersMatched++;
                        }
                        break;
                    case 'state':
                        if ($item.find('.image-item').first().data('state') === value) {
                            filtersMatched++;
                        }
                        break;
                    }
                } else if ($activeFilter.hasClass('reset-filter')) {
                    filtersMatched++;
                }
            });

            if (filtersMatched < $activeFilters.length) {
                $item.addClass('d-none');
            }
        });
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/customerFilter.js